// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"275":"7d316a39","422":"97865cdd","835":"272f4f94","987":"f296b8f3"}[chunkId] + ".chunk.css";
};